var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetenttempLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 600 210",
    viewBox: "0 0 600 210",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "496.5 45.1 496.5 68.3 523.9 68.3 523.9 165.2 547.8 165.2 547.8 68.3 575 68.3 575 45.1",
    fill: "#86BD48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463 118.7 416.9 45.1 395.5 45.1 395.5 165 419.2 165 419.2 91.3 465.3 165 486.8 165 486.8 45.1 463 45.1",
    fill: "#86BD48"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.6 68.1 245 68.1 245 165 268.8 165 268.8 68.1 296.1 68.1 296.1 45 217.6 45",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.7 164.9 208 164.9 208 142.2 153.5 142.2 153.5 116 200.1 116 200.1 93.1 153.5 93.1 153.5 67.8 208 67.8 208 44.9 129.7 44.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.5 118.5 46.4 45 25 45 25 164.9 48.7 164.9 48.7 91.2 94.8 164.9 116.4 164.9 116.4 45 92.6 45 92.6 118.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.7 7.5 307.2 7.5 307.2 202.5 312.7 202.5 312.7 164.9 383.5 164.9 383.5 142.2 329.1 142.2 329.1 116 375.6 116 375.6 93.1 329.1 93.1 329.1 67.8 383.5 67.8 383.5 44.9 312.7 44.9",
    fill: "#86BD48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetenttempLogo);
export default __webpack_public_path__ + "static/media/netenttemp-logo.9c175c91c29256441c0f212c7cb9e590.svg";
export { ForwardRef as ReactComponent };